import $ from 'jquery';

const Uploader = function() {};

Uploader.prototype.init = function(options, elem) {
    this.elem = elem;
    this.$elem = $(elem);

    this.options = options;

    this.$elem.append(this._build(options, this.$elem));
    this._bindEvents(options, this.$elem);

    return this;
};

Uploader.prototype.updateLink = function($item, url, title) {
    return $item
        .find('.uploader__box')
        .attr('target', '_blank')
        .attr('title', title)
        .prop('href', url);
};

Uploader.prototype._build = function(options, $elem) {
    var that = this;

    $('<div />', {'class' : 'hidden'}).fineUploader({
        listElement: $elem.find(options.listselector),
        button: options.button || $elem.find(options.buttonselector),
        fileTemplate: options.template,
        text: {
            dropProcessing: '',
            formatProgress: '{percent}%',
            waitingForResponse: ''
        },
        dragAndDrop: {
            disableDefaultDropzone: true,
            extraDropzones: options.extraDropzones,
            hideDropzones: false
        },
        request: {
            forceMultipart: true,
            paramsInBody: true,
            endpoint: options.endpoint,
            params: options.params,
            uuidName: '',
            inputName: options.inputname,
            filenameParam: 'key',
            totalFileSizeName: options.totalfilesizename
        },
        validation: {
            sizeLimit: options.sizelimit,
            allowedExtensions: options.allowedextensions
        },
        classes: options.classes
    })
    .on('submit', $.proxy(function(event, id, path) {
        that._triggerEvent('submit', {
            id: id,
            path: path
        });
    }, this))
    .on('submitted', $.proxy(function(event, id, path) {
        /* jshint maxcomplexity:false */
        var uploader = $(event.target).data('fineuploader').uploader,
            $item = $(uploader.getItemByFileId(id)),
            file = uploader.getFile(id);

        uploader.setName(id, that._getFilePath(id, path));

        $item.attr('data-uploader-id', id);
        $item.find('.uploader__fileext').text(that._getFileExt(path));

        if (options.hidefileinfo) {
            $item.addClass('uploader__item--hide-file-info');
        }

        if (file) {
            $item.find('uploader__filesize').text(uploader._formatSize(file.size)); // Sneaky use of private method

            if (file.type.match(/^image\/(jpeg|png|gif)/)) {
                // Show image thumbnail
                $item.find('.uploader__thumb').css({
                    'background-image': 'url(' + (window.URL || window.webkitURL).createObjectURL(file) + ')'
                })
                    .addClass('uploader__thumb--solid');
            }
        }

        that._setUploading($item, true);

        that._triggerEvent('submitted', {
            id: id,
            path: path,
            element: $item.get(0)
        });
    }, this))
    .on('complete', $.proxy(function(event, id, path, responseJSON, xhr) {
        var uploader = $(event.target).data('fineuploader').uploader,
            item = uploader.getItemByFileId(id),
            $item = $(item);

        $item.attr('data-uploader-complete', true);

        that._setUploading($item, false);

        if (responseJSON.deleteUrl) {
            $item.find('.js-delete-file').attr('href', responseJSON.deleteUrl);
        }

        that._triggerEvent('complete', {
            id: id,
            path: path,
            inProgress: uploader.getInProgress(),
            response: responseJSON,
            element: item,
            xhr: xhr
        });
    }, this))
    .on('error', $.proxy(function(event, id, path, errorReason, xhr) {
        var uploader = $(event.target).data('fineuploader').uploader;

        that._triggerEvent('error', {
            id: id,
            path: path,
            reason: errorReason,
            element: uploader.getItemByFileId(id),
            xhr: xhr
        });
    }, this));
};

Uploader.prototype._bindEvents = function(options, $elem) {
    var that = this;

    $elem.on('click', '.js-delete-file', function(e) {
        e.preventDefault();

        var $closeBtn = $(this),
            $item = $closeBtn.closest('.uploader__item'),
            itemID = $item.data('uploader-id'),
            itemComplete = $item.data('uploader-complete');

        // cancel it
        if (!itemComplete && itemID && $elem.data('fineuploader')) {
            $elem.data('fineuploader').uploader.cancel(itemID);
        }

        if ($closeBtn.attr('href') && $closeBtn.attr('href') !== '#') {
            $closeBtn.css('pointer-events', 'none');

            that._triggerEvent('delete', {
                element: $item.get(0)
            });

            $item.addClass(options.classes.waiting);

            $.ajax(
                $closeBtn.attr('href'),
                { type: 'POST' }
            )
                .done(function(data, status, xhr) {
                    that._removeItem($item);

                    that._triggerEvent('deleteComplete', {
                        element: $item.get(0),
                        data: data,
                        status: status,
                        xhr: xhr
                    });
                })
                .fail(function() {
                    that._triggerEvent('deleteFail', {
                        element: $item.get(0)
                    });
                })
                .always(function() {
                    $closeBtn.css('pointer-events', 'auto');
                    $item.removeClass(options.classes.waiting);
                });
        } else {
            that._removeItem($item);

            that._triggerEvent('deleteComplete', {
                element: $item.get(0)
            });
        }
    });
};


// Figure out where in S3 the file was uploaded to
// Uses the id to allow multiple files with the same name
Uploader.prototype._getFilePath = function(id, name) {
    return this.options.hash + '/' + id + '/' + name;
};

Uploader.prototype._getFileExt = function(name) {
    return name.match(/(?:\.([^.]+))?$/)[1];
};

Uploader.prototype._removeItem = function($item) {
    $item.remove();
};

Uploader.prototype._triggerEvent = function(event, data) {
    return $(document).trigger(
        'uploader:' + event + ':' + this.options.name,
        data
    );
};

Uploader.prototype._setUploading = function($item, isUploading) {
    if (isUploading) {
        $item.addClass(this.options.classes.uploading);
    } else {
        $item.removeClass(this.options.classes.uploading);
    }
};

export default Uploader;



// WEBPACK FOOTER //
// ./src/web/js/launch/lib/legacy-uploader-lib.js